import moment from "moment";

// Regras puras da tela de Agendamentos (mockup "Tela Aeros Dark -
// Agendamentos"): classificação do evento no calendário, KPIs do painel
// lateral, lista de próximos envios e prévia de recorrência do modal.

// Unidades do campo `intervalo` (contrato do backend em queues.ts)
export const INTERVAL_UNITS = {
  1: "days",
  2: "weeks",
  3: "months",
  4: "minutes",
};

export const isRecurring = (s) =>
  Number(s?.enviarQuantasVezes) > 1 && Number(s?.valorIntervalo) > 0;

// pend (ciano) · sent (verde) · rec (roxo) · err (vermelho)
export const scheduleKind = (s) => {
  if (!s) return "pend";
  if (s.status === "ERRO") return "err";
  if (s.sentAt || s.status === "ENVIADA") return "sent";
  if (isRecurring(s)) return "rec";
  return "pend";
};

const isOpen = (s) => {
  const kind = scheduleKind(s);
  return kind === "pend" || kind === "rec";
};

export const countThisWeek = (schedules, now = new Date()) => {
  const start = moment(now).startOf("week");
  const end = moment(now).endOf("week");
  return (schedules || []).filter((s) => {
    if (!isOpen(s)) return false;
    const at = moment(s.sendAt);
    return at.isSameOrAfter(start) && at.isSameOrBefore(end);
  }).length;
};

export const countFailed = (schedules) =>
  (schedules || []).filter((s) => scheduleKind(s) === "err").length;

// Pendentes a partir de hoje (asc) e, depois, falhas (mais recente primeiro).
export const upcomingSchedules = (schedules, now = new Date(), limit = 5) => {
  const today = moment(now).startOf("day");
  const pending = (schedules || [])
    .filter((s) => isOpen(s) && moment(s.sendAt).isSameOrAfter(today))
    .sort((a, b) => moment(a.sendAt).valueOf() - moment(b.sendAt).valueOf());
  const failed = (schedules || [])
    .filter((s) => scheduleKind(s) === "err")
    .sort((a, b) => moment(b.sendAt).valueOf() - moment(a.sendAt).valueOf());
  return [...pending, ...failed].slice(0, limit);
};

export const filterByCanal = (schedules, canal) => {
  if (!canal || canal === "all") return schedules || [];
  return (schedules || []).filter((s) => (s.canal || "whatsapp") === canal);
};

// Datas dos próximos envios: o primeiro é o próprio sendAt (ou o lembrete,
// que substitui o horário original) e o segundo só existe com recorrência.
export const nextSendDates = ({
  sendAt,
  reminderDate,
  intervalo,
  valorIntervalo,
  enviarQuantasVezes,
}) => {
  const first = reminderDate ? moment(reminderDate) : moment(sendAt);
  if (!first.isValid()) return [];
  const times = Number(enviarQuantasVezes) || 1;
  const step = Number(valorIntervalo) || 0;
  const unit = INTERVAL_UNITS[Number(intervalo)] || "days";
  if (times <= 1 || step <= 0) return [first];
  return [first, moment(first).add(step, unit)];
};
